import React, { useState } from "react";

import { Avatar, IconButton, Stack, TextField } from "@mui/material";
import { SendIcon } from "assets/material-custom-icons";

interface Props {
  currentUserAvatarUrl?: string;
  onAddComment: (text: string) => void;
}

export const CommentInput: React.FC<Props> = ({ currentUserAvatarUrl, onAddComment }) => {
  const [commentText, setCommentText] = useState("");

  const handleSend = () => {
    if (commentText.trim()) {
      onAddComment(commentText.trim());
      setCommentText("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Stack direction="row" gap="10px" alignItems="flex-start" sx={{ py: "10px" }}>
      <Avatar
        src={currentUserAvatarUrl}
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          flexShrink: 0,
          mt: "8px"
        }}
      />
      <TextField
        placeholder="Type a comment"
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        onKeyPress={handleKeyPress}
        fullWidth
        multiline
        minRows={1}
        maxRows={4}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            fontSize: "16px",
            alignItems: "center",
            "& fieldset": {
              borderColor: "#7b92a9"
            },
            "&:hover fieldset": {
              borderColor: "#7b92a9"
            },
            "&.Mui-focused fieldset": {
              borderColor: "#7b92a9"
            },
            "&.MuiInputBase-multiline": {
              paddingTop: "8px",
              paddingBottom: "8px"
            }
          },
          "& .MuiInputBase-input": {
            py: 0,
            px: "8px",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#071f35",
            "&::placeholder": {
              color: "#92a7bc",
              opacity: 1
            }
          },
          "& .MuiInputBase-inputMultiline": {
            paddingTop: 0,
            paddingBottom: 0
          }
        }}
        InputProps={{
          endAdornment: (
            <IconButton
              onClick={handleSend}
              disabled={!commentText.trim()}
              sx={{
                width: 24,
                height: 24,
                p: 0,
                color: commentText.trim() ? "#496682" : "#92a7bc",
                alignSelf: "flex-end",
                mt: "8px"
              }}
            >
              <SendIcon sx={{ fontSize: "24px" }} />
            </IconButton>
          )
        }}
      />
    </Stack>
  );
};
